<template>
    <v-container fluid no-gutters class="my-0 py-0">
        <filters :cup="true" @getScheduleByLeague="getByFilters" @getByFilters="getByFilters" @getCupState="getCupState" @clear="clearData" />
        <schedule-match-center :matches="matches" :loading="loading" />
    </v-container>
</template>

<script>
    import ScheduleMatchCenter from '@/components/ScheduleMatchCenter'
    import Filters from '@/components/GenericFilters'
    import matchService from '@/services/match'
    import { pollWhileVisible, SCHEDULE_REFRESH_MS } from '@/utils/matchLive'

    export default {
        components: { ScheduleMatchCenter, Filters },
        data() {
            return {
                matches: [],
                filter: {},
                // the filters of the list on screen, for the background reloads
                lastFilters: null,
                requestId: 0,
                loading: false,
                stopRefresh: null
            }
        },
        created() {
            this.stopRefresh = pollWhileVisible(() => {
                if (this.lastFilters && !this.loading) {
                    this.fetchMatches(this.lastFilters, true)
                }
            }, SCHEDULE_REFRESH_MS)
        },
        beforeDestroy() {
            this.stopRefresh()
        },
        methods: {
            // another season: nothing on screen until its matches come
            clearData() {
                this.requestId++
                this.lastFilters = null
                this.matches = []
                this.loading = false
            },
            // silent: a background reload, without the loader
            fetchMatches(filters, silent = false) {
                this.lastFilters = filters
                const requestId = ++this.requestId
                if (!silent) {
                    this.loading = true
                }
                matchService.getMatches(1, 100, filters).then(resp => {
                    // a later request (other filters) wins over an older one still on the way
                    if (requestId === this.requestId) {
                        this.matches = resp.data.content
                    }
                }).catch(() => {}).finally(() => {
                    if (requestId === this.requestId) {
                        this.loading = false
                    }
                })
            },
            getCupState(isCup, leagueId, seasonId) {
                let filters = {}
                if (isCup) {
                    filters = { cup: `isCup: ${isCup}` }
                } else {
                    filters = { phase: 'phase: playoffs', league: `league: ${leagueId}`, season: `season: ${seasonId}` }
                }
                this.fetchMatches(filters)
            },
            getByFilters(round = null, arenaId = null, isCup = null, leagueId = null, seasonId = null, phase = null) {
                this.filter = { query: '{' }
                if (round) {
                    this.filter.query += `"round":"${round}",`
                }
                if (arenaId !== null) {
                    this.filter.query += `"arena":"${arenaId}",`
                }
                if (isCup) {
                    this.filter.query += `"isCup":${isCup},`
                } else if (phase !== null) {
                    this.filter.query += `"phase":"${phase}",`
                }
                if (leagueId !== null) {
                    this.filter.query += `"league":"${leagueId}",`
                }
                if (seasonId !== null) {
                    this.filter.query += `"season":"${seasonId}",`
                }

                // remove trailing comma (if any) and close the JSON-like query
                if (this.filter.query.endsWith(',')) {
                    this.filter.query = this.filter.query.slice(0, -1)
                }
                this.filter.query += '}'

                this.fetchMatches(this.filter)
            }
        }
    }
</script>
